module.exports = __webpack_public_path__ + "static/media/down_blk.4b342189.svg";